import { Link } from 'react-router-dom'
import BrandLogo from '../Assetes/Images/KFC-Logo-Red.png'
import AppStor from '../Assetes/Images/app-store.png'
import GoogleStor from '../Assetes/Images/google-store.png'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import useCurrentLocale from '../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import React from 'react';

export default function Footer() {
    const lang = useCurrentLocale();
    const { t } = useTranslation();
    return (
        <div className='footer-container'>
            <div className="container">
                <div className="social-container">
                    <img src={BrandLogo} alt="brand-logo" style={{ cursor: "pointer" }} onClick={() => window.scrollTo(0, 0)} />
                    <div className="footer-line"></div>
                    <div className="">
                        <div className='social-icons'>
                    
                            <a href='https://www.instagram.com/kfcalgeria/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D#' target='blank'><i className="ri-instagram-line"></i></a>
                            <a href="https://www.facebook.com/people/KFC-Algeria/61560719602310/" target='blank'><i className="ri-facebook-fill"></i></a>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <ul className='footer-info'>


                        <Link to={`/${lang}/about-us`}><li>{t("ABOUT_US")}</li></Link>
                            {/* <Link to={`/${lang}/mitao-bhook`}><li>{t("MITAO_BHOOK")}</li></Link> */}
                            {/* <Link to={`/${lang}/mitao-bhook-scholarship`}><li>{t("MITAO_BHOOK_SCHOLARSHIP")}</li></Link> */}
                            <Link to={`/${lang}/privacy-policy`}><li>{t("PRIVACY_POLICY")}</li></Link>
                            {/* <Link to={`/${lang}/careers-page`}> <li>{t("CAREERS")}</li></Link> */}
                        </ul>
                    </div>
                    <div className="col-md-3">
                        <ul className='footer-info'>

                            {/* <Link to={`/${lang}/Contact-Us`}><li>{t("CONTACT_US")}</li></Link> */}
                            <Link to={`/${lang}/store-locations`}><li>{t("STORE_LOCATOR")}</li></Link>
                            <Link to={`/${lang}/track-order`}><li>{t("TRACK_ORDER")}</li></Link>
                        </ul>
                    </div>
                    <div className="col-md-3">
                        <ul className='footer-info'>
                        <Link to={`/${lang}/terms-condition`}><li>{t("TERMS_CONDITIONS")}</li></Link>
                        </ul>
                    </div>
                    <div className="col-md-3">
                        <div className='app-kfc'>
                        <a href='' target="_blank">  <img className='mt-3 store-icon-image' src={AppStor} alt="AppStor" /></a>
                        <a href='' target="_blank">  <img className='mt-3 store-icon-image' src={GoogleStor} alt="GoogleStor" /></a>
                        <div className='powerd-by mt-2 mobile-powered'>
                            <h1>{t("POWERED_BY")}</h1>
                            <a href='https://simplexts.net/' target="_blank">SimpleX Technology Solutions</a>
                            <h6>&copy; KFC. {t("ALL_RIGHTS_RESERVED")}</h6>
                        </div>
                        </div>
                    </div>
                    <div className='powerd-by kfc-all-rights mt-2 d-flex justify-content-between align-items-end'>
                        <h6 className='m-0'>&copy; KFC. {t("ALL_RIGHTS_RESERVED")}</h6>
                        <div>
                            <h1>{t("POWERED_BY")}</h1>
                            <a href='https://simplexts.net/' target="_blank">SimpleX Technology Solutions</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
